import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { useNavigate } from "react-router-dom";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ModalEnvioPostal = (props: { data; frete; onAgree ;onDisagree; isAllowedPortador }) => {
  const [open, setOpen] = React.useState(true);
  const [total, setTotal] = React.useState(0);
  const [divisaoEntrega, setDivisaoEntrega] = React.useState(0);
  const frete = props.frete;
  const navigate = useNavigate();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickAgree = () => {
    props.onAgree(frete.valor * divisaoEntrega);
    setOpen(false);
  };
  const handleClickDisagree = () => {
    props.onDisagree();
    setOpen(false);
  };

  const handleClose = (
    event: object,
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    // Impede fechar por clique no fundo ou tecla Esc
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }

    // Aqui você permite o fechamento
    setOpen(false);
  };

  React.useEffect(() => {
    console.log(props.data);
    if (props.data && props.data.length > 0) {
      setData();
    }
    function setData() {
      let totalValue = 0;
      props.data.forEach((item) => {
        totalValue += item.valor * item.quantidade;
      });
      setTotal(totalValue);

      setDivisaoEntrega(Math.ceil(totalValue / 10000));
    }
  }, [props.data]);

  React.useEffect(() => {
    const handlePopState = (e: PopStateEvent) => {
      // Impede que o modal seja fechado
      if (open) {
        window.history.pushState(null, "", window.location.href);
      }
    };

    if (open) {
      // Cria um novo histórico para "travar" o voltar
      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", handlePopState);
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [open]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        disableEscapeKeyDown
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Limite de Compra atingido!</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Informamos que, para a forma de entrega via <b>Envio Postal</b>, o
            limite por remessa é de <strong>R$ 10.000,00</strong>.
          </DialogContentText>
          <DialogContentText>
            <br />
            Como o valor total da sua compra foi de{" "}
            <b>
              {total.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}
            </b>{" "}
            será necessário dividir o envio em {divisaoEntrega} remessas,
            respeitando esse limite. Dessa forma, garantimos que suas moedas
            sejam enviadas com segurança e dentro das normas estabelecidas.
          </DialogContentText>
          <DialogContentText>
            <br />O custo de entrega por remessa é de{" "}
            <b>
              {frete.valor.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}
            </b>
            , como serão {divisaoEntrega} entregas, o valor total do frete será
            de{" "}
            <b>
              {(frete.valor * divisaoEntrega).toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}
            </b>
            .
          </DialogContentText>
          {props.isAllowedPortador &&
          <DialogContentText>
          <br />
          <b>Alternativamente, você pode optar pela entrega via Portador</b>,
          realizada diretamente por nossa equipe. Essa modalidade não possui
          limite de valor por envio, sendo ideal para compras acima de{" "}
          <b>R$ 10.000,00</b>. Disponível para São Paulo e regiões atendidas conforme as  <button onClick={() => navigate("/om/cambio/moedas-estrangeiras/#politica-entrega-cambio")}>Políticas de Entrega.</button>
        </DialogContentText>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickDisagree}>Alterar forma de entrega</Button>
          <Button onClick={handleClickAgree}><b>Continuar</b></Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
